import { FormikProps, useFormik } from "formik";
import { useHandleChange } from "@arelia-hooks/formikHooks";
import AccountDetailsPresenter from "./AccountDetailsPresenter";
import { Account } from "@arelia-types/index";

type Props = {
  accountDetails: Account;
  update: (cutomerUpdates: Partial<Account>) => void;
};

export type EditForm = {
  email: string;
  labelOrManager: string;
  fullName: string;
  phone: string;
  address: string;
};

export default function AccountDetailsContainer({ accountDetails, update }: Props) {
  const mapper = ({ address, email, fullName, labelOrManager, phone }: EditForm) => ({
    fullName,
    email,
    address,
    phone,
    band: { labelOrManager }
  } as Partial<Account>);

  const submitUpdates = (updates: EditForm) => update(mapper(updates));

  const formik: FormikProps<EditForm> = useFormik<EditForm>({
    initialValues: {
      address: accountDetails.address,
      email: accountDetails.email,
      fullName: accountDetails.fullName,
      labelOrManager: accountDetails.band?.labelOrManager,
      phone: accountDetails.phone,
    },
    onSubmit: submitUpdates,
    enableReinitialize: true,
  });

  const handeChange = useHandleChange<EditForm>(formik);

  return <AccountDetailsPresenter
    formik={formik}
    handeChange={handeChange}
  />;
}